// @flow

import styled from 'styled-components';
import { COLORS, SPACING, TYPE_SCALE, LINE_HEIGHT, FONT_WEIGHT } from 'clark-styles';

const { GREY_100, GREY_50 } = COLORS;
const { S_05, S_2 } = SPACING;
const { TS_1, TS_4, TS_6 } = TYPE_SCALE;
const { TITLE, COPY } = LINE_HEIGHT;
const { FW_100, FW_400 } = FONT_WEIGHT;

export const Wrapper = styled.div`
  margin-top: ${S_2};
`;

export const Headline = styled.h3`
  ${FW_400};
  ${TS_6};
  ${TITLE};
  color: ${GREY_50};
  margin: 0 0 ${S_05};
  text-transform: uppercase;
`;

export const Copy = styled.p`
  ${FW_100};
  ${TS_4};
  ${COPY};
  color: ${GREY_100};
  margin: 0 0 ${S_2};

  &:last-child {
    margin: 0;
  }
`;

export const SessionScore = styled.span`
  ${FW_100};
  ${TS_1};
  color: ${GREY_100};
  padding: ${S_05} 0;
`;

export const ScoreExplainer = styled.p`
  ${FW_100};
  ${TS_6};
  ${COPY};
  color: ${GREY_50};
  margin: ${S_05} 0 ${S_2} 0;
`;



// WEBPACK FOOTER //
// ./src/components/sessions/view/report-details/styles.js